export const roles = {
  SYSTEM_ADMIN: "sys_adm",
  SUB_ADMIN: "sub_admin",
  USER: "user",
  PRODUCT_MANAGER_STUDENT: "product_manager_student",
  TEAMMEMBERSHIP_OWNER: "owner",
  TEAMMEMBERSHIP_ADMIN: "admin",
  MENTOR: "mentor",
  OWNER: "owner",
  TENANT_ADMIN: "admin",
  TENANT_STUDENT: "student",
  BUISNESS_ANALYST_STUDENT: "business_analyst_student",
  SCRUM_MASTER_STUDENT: "scrum_master_student",
  PRODUCT_OWNER_STUDENT: "product_owner_student",
  SELF_PACED_PRODUCT_MANAGER_STUDENT: "self_paced_product_manager",
  SELF_PACED_SCRUM_MASTER_STUDENT: "self_paced_scrum_master",
  SELF_PACED_PRODUCT_OWNER_STUDENT: "self_paced_product_owner",
  SELF_PACED_BUSINESS_ANALYST_STUDENT: "self_paced_business_analyst",
  SELF_PACED_PDM_STUDENT: "self_paced_pdm_student",
  SELF_PACED_AGILE_PROJECT_MANAGER_STUDENT: "self_paced_agile_project_manager",
  SELF_PACED_PRODUCT_MANAGER_LANDING: "self_paced_product_manager_landing",
  SELF_PACED_PRODUCT_OWNER_LANDING: "self_paced_product_owner_landing",
  SELF_PACED_BUSINESS_ANALYST_LANDING: "self_paced_business_analyst_landing",
  SELF_PACED_SCRUM_MASTER_LANDING: "self_paced_scrum_master_landing",
  FREE_SELF_PACED_BUSINESS_ANALYST_STUDENT: "free_self_paced_business_analyst",
  AA_ICP_CERTIFCATION: "aa_icp_certification",
  AA_ICP_PDM_CERTIFCATION: "aa_icp_pdm_certification",
  AI_BUSINESS_ANALYST_STUDENT: "ai_business_analyst",
  FREE_SELF_PACED_PRODUCT_OWNER_STUDENT: "free_self_paced_product_owner",
  UDEMY_SELF_PACED_ICP_STUDENT: "udemy_self_paced_icp_student",
  UDEMY_SELF_PACED_PDM_STUDENT: "udemy_self_paced_pdm_student",
  ICP_STUDENT: "icp_student",
  APO_STUDENT: "apo_student",
  PDM_STUDENT: "pdm_student",
  ICP_ACC_STUDENT: "icp_acc_student",
  ATF_STUDENT: "atf_student",
  FAI: "fai",
  // PDM_SELF_PACED_STUDENT: "pdm_self_paced_student",
};
